import React from 'react';

import AddPersonIcon from 'icons/addperson-xl.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';

export default function AddPersonnelSection({ onAddClick }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'personnel.AddPersonnelSection',
  });

  const { t: i18nTPersonnel } = useTranslation('common', {
    keyPrefix: 'personnel',
  });

  return (
    <section className='section section--notice tw-border-grey-100 tw-bg-white'>
      <AddPersonIcon
        className='-tw-mb-2 [&_path]:tw-fill-grey-500'
        height={64}
        width={64}
      />
      <h2 className='section__header tw-text-l tw-font-semibold tw-text-grey-900'>
        {i18nTPersonnel('addPersonnel')}
      </h2>
      <p className='section__content'>{i18nT('descriptionOne')}</p>
      <p className='section__content'>{i18nT('descriptionTwo')}</p>
      <FilledButton color='mint' onClick={onAddClick}>
        {i18nTPersonnel('addNewPersonnel')}
      </FilledButton>
    </section>
  );
}

AddPersonnelSection.propTypes = {
  onAddClick: PropTypes.func,
};
